export default __webpack_public_path__ + "static/media/battery-full-solid.8b47db02.svg";